export const LTCV_FOR_PMI_REMOVAL = 80
export const EQUITY_FOR_PMI_REMOVAL = 20
export const UPPER_LTCV_THRESHOLD_FOR_PMI_REMOVAL = 82
export const NOT_YET = 0
export const SOON = 1
export const NOW = 2
